import type { Issuance, IssuanceInput } from 'generated/gql';

import { mapShareSeriesToShareSeriesInput } from './ShareSeries';

export const mapIssuanceToIssuanceInput = (issuance: Issuance): IssuanceInput => ({
  toPartyId: issuance.to.id,
  shareSeries: mapShareSeriesToShareSeriesInput(issuance.shareSeries),
  paid: issuance.paid,
});
